import image1 from '../assets/images/mountain-1.png';
import image2 from '../assets/images/mountain-2.png';
import image3 from '../assets/images/mountain-3.png';
import image4 from '../assets/images/mountain-4.png';
import image5 from '../assets/images/mountain-5.png';
import image6 from '../assets/images/mountain-6.png';
import image7 from '../assets/images/mountain-7.png';
import image8 from '../assets/images/mountain-8.png';

export const contentData = [
  {
    id: "1001",
    title: "Denali National Park and Preserve",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum.",
    slug: "lorem-ipseum",
    image: image1
  },
  {
    id: "1002",
    title: "Beautiful peaks of the Himalayas",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum.",
    slug: "himalayas",
    image: image2
  },
  {
    id: "1003",
    title: "Karakoram Range in Northern Pakistan",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum. Lorem ipsum dolor sit amet, consectetur adipiscing.",
    slug: "northern-pakistan",
    image: image3
  },
  {
    id: "1004",
    title: "Mount Kilimanjaro",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum.",
    slug: "kilimanjaro",
    image: image4
  },
  {
    id: "1005",
    title: "Olympus Range of Greece",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum.",
    slug: "olympus-greece",
    image: image5
  },
  {
    id: "1006",
    title: "Mont Blanc",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum. Lorem ipsum dolor sit amet, consectetur adipiscing.",
    slug: "mont-blanc",
    image: image6
  },
  {
    id: "1007",
    title: "The peaks of Patagonia",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum.",
    slug: "patagonia",
    image: image7
  },
  {
    id: "1008",
    title: "Dolomites of Italy",
    title_long: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod ex ut blandit condimentum.",
    slug: "aenean-vulputate",
    image: image8
  }
]